function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitterinline = function SvgTwitterinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11 0a11 11 0 1 0 11 11A11 11 0 0 0 11 0Zm5.669 8.49q.008.163.008.327v.118A7.33 7.33 0 0 1 9.088 16 7.863 7.863 0 0 1 5 14.866a5.7 5.7 0 0 0 .636.034 5.546 5.546 0 0 0 3.313-1.08 2.656 2.656 0 0 1-2.491-1.755 2.817 2.817 0 0 0 1.2-.043 2.566 2.566 0 0 1-2.14-2.475v-.032a2.771 2.771 0 0 0 1.208.316 2.491 2.491 0 0 1-1.187-2.1A2.411 2.411 0 0 1 5.9 6.462 7.721 7.721 0 0 0 11.4 9.1a2.4 2.4 0 0 1-.067-.576A2.6 2.6 0 0 1 14 6a2.736 2.736 0 0 1 1.947.8 5.527 5.527 0 0 0 1.694-.613 2.562 2.562 0 0 1-1.173 1.4A5.567 5.567 0 0 0 18 7.184a5.265 5.265 0 0 1-1.331 1.306Z",
    style: {
      fill: "#282828",
      fillRule: "evenodd"
    }
  }));
};
export default SvgTwitterinline;